import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import PropertyListings from './pages/PropertyListings';
import PropertyDetails from './pages/PropertyDetails';
import Dashboard from './pages/Dashboard';
import Services from './pages/Services';
import TrackDelivery from './pages/TrackDelivery';
import Chat from './pages/Chat';
import Authentication from './pages/Authentication';
import AdminPanel from './pages/AdminPanel';
import Layout from './components/Layout/Layout';
import KycVerification from './pages/KycVerification';
import PaymentGateway from './pages/PaymentGateway';
import EscrowServices from './pages/EscrowServices';
import VeriBotPage from './pages/VeriBotPage';
import VeriBotWidget from './components/VeriBot/VeriBotWidget';
// Add a mobile detector
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
export function App() {
  return <div className={`app-container ${isMobile ? 'mobile-device' : ''}`} data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Layout data-id="element-4">
                <HomePage data-id="element-5" />
              </Layout>} data-id="element-3" />
          <Route path="/auth" element={<Authentication data-id="element-7" />} data-id="element-6" />
          <Route path="/properties" element={<Layout data-id="element-9">
                <PropertyListings data-id="element-10" />
              </Layout>} data-id="element-8" />
          <Route path="/properties/:id" element={<Layout data-id="element-12">
                <PropertyDetails data-id="element-13" />
              </Layout>} data-id="element-11" />
          <Route path="/dashboard" element={<Layout data-id="element-15">
                <Dashboard data-id="element-16" />
              </Layout>} data-id="element-14" />
          <Route path="/services" element={<Layout data-id="element-18">
                <Services data-id="element-19" />
              </Layout>} data-id="element-17" />
          <Route path="/track" element={<Layout data-id="element-21">
                <TrackDelivery data-id="element-22" />
              </Layout>} data-id="element-20" />
          <Route path="/chat" element={<Layout data-id="element-24">
                <Chat data-id="element-25" />
              </Layout>} data-id="element-23" />
          <Route path="/admin" element={<Layout data-id="element-27">
                <AdminPanel data-id="element-28" />
              </Layout>} data-id="element-26" />
          <Route path="/kyc" element={<Layout data-id="element-30">
                <KycVerification data-id="element-31" />
              </Layout>} data-id="element-29" />
          <Route path="/payment" element={<Layout data-id="element-33">
                <PaymentGateway data-id="element-34" />
              </Layout>} data-id="element-32" />
          <Route path="/escrow" element={<Layout data-id="element-36">
                <EscrowServices data-id="element-37" />
              </Layout>} data-id="element-35" />
          <Route path="/veribot" element={<Layout data-id="element-39">
                <VeriBotPage data-id="element-40" />
              </Layout>} data-id="element-38" />
        </Routes>

        {/* Global VeriBot Widget */}
        <VeriBotWidget data-id="element-41" />
      </BrowserRouter>
    </div>;
}